export interface ShiftHistory {
  date: string;
  startTime: string;
  endTime: string;
  facility: string;
  location: string;
  scopeOfPractice: string;
  rate: number;
  totalPaid: number;
}
